import { z } from "zod";

import { ExclusionGroupDtoSchema } from "../../../../dtos/exclusion-group";

import { PluginExclusionGroupEntitySchema } from "./exclusionGroupEntities";

export const PluginExclusionGroupSchema_2024_05_05 =
  ExclusionGroupDtoSchema.extend({
    exclusionGroupEntities: PluginExclusionGroupEntitySchema.array(),
  });
export type PluginExclusionGroupType_2024_05_05 = z.infer<
  typeof PluginExclusionGroupSchema_2024_05_05
>;
